import React, { Component } from "react";

import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { Swiper, SwiperSlide } from "swiper/react/swiper-react";
import { Pagination, Autoplay } from "swiper";
import "swiper/swiper.min.css";
// import "swiper/swiper-bundle.css";
import "swiper/modules/pagination/pagination.min.css";
import "swiper/modules/navigation/navigation.min.css";
import "./SwiperSlider.scss";

import { FormattedMessage } from "react-intl";
import { Height } from "@mui/icons-material";
class SwiperSlider extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div className="swiper-container">
        <Swiper
          modules={[Pagination, Autoplay]}
          pagination={{
            clickable: true,
            type: "bullets",
          }}
          autoplay={{ delay: 10000 }}
          loop={true}
          speed={800}
          effect="slide"
        >
          <SwiperSlide>
            <div id="home" className="hero-area" style={{ paddingTop: 0 }}>
              <video
                id="homeVideo"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              >
                <source src="/static/video/anovator_v2.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div id="home" className="hero-area" style={{ paddingTop: 0 }}>
              <video
                id="homeVideo"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                style={{
                  width: "100%",
                  height: "auto",
                  display: "block",
                }}
              >
                <source src="/static/video/video1.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div id="home" className="hero-area" style={{ paddingTop: 0 }}>
              <video
                id="homeVideo"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                style={{ width: "100%", height: "auto", display: "block" }}
              >
                <source src="/static/video/video2.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </SwiperSlide>

          <SwiperSlide>
            <div id="home" className="hero-area" style={{ paddingTop: 0 }}>
              <video
                id="homeVideo"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                style={{ width: "100%", height: "auto", display: "block" }}
              >
                <source src="/static/video/video1.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </SwiperSlide>
          <SwiperSlide>
            <div id="home" className="hero-area" style={{ paddingTop: 0 }}>
              <video
                id="homeVideo"
                autoPlay
                loop
                muted
                playsInline
                preload="auto"
                style={{ width: "100%", height: "auto", display: "block" }}
              >
                <source src="/static/video/video2.mp4" type="video/mp4" />
                Your browser does not support the video tag.
              </video>
            </div>
          </SwiperSlide>
          {/* <SwiperSlide>
            <div className="main-img">
              <picture>
                <source
                  media="(max-width: 768px)"
                  srcSet="/static/images/banner/banner01.png"
                  type="image/webp"
                />
                <img
                  src="/static/images/banner/banner01.png"
                  data-src="/static/images/banner/banner01.png"
                  alt=""
                />
              </picture>
            </div>
          </SwiperSlide> */}
        </Swiper>

        {/* <div className="swiper-pagination"></div> */}
        <div className="scroll-mouse">
          <img
            style={{ width: 30, height: 30 }}
            src="/static/images/mouse-w.png"
            alt="Scroll Mouse"
          />
          <p style={{ color: "#FFFFFF", fontSize: 12, marginTop: 10 }}>
            {/* <FormattedMessage id="home.slider.a3" /> */}
          </p>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.app.language,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};
export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(SwiperSlider)
);
